
import financial from './financial'
import periodClose from './period-close'
import calendar from './calendar'

export default {
  namespaced: true,
  modules: {
    financial,
    periodClose,
    calendar,
  },
  state: {},
  mutations: {},
  actions: {},
}
